import { useMediaQuery } from './useMediaQuery';

export const useMobileDetection = (breakpoint: number = 768) => {
  const mediaQuery = `(max-width: ${breakpoint}px)`;
  const isMobile = useMediaQuery(mediaQuery);
  return isMobile;
};
